module.exports = __webpack_public_path__ + "img/arrr.1db34df8.svg";